import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {NgxMaskModule} from "ngx-mask";
import {LoaderComponent} from "./loader/loader.component";
import {MatSelectModule} from "@angular/material";
import {DemoMaterialModule} from "../material.module";
import {RouterModule} from "@angular/router";
import {PopupWrapperComponent} from "./popup-wrapper/popup-wrapper.component";
import {MainTabsComponent} from "./main-tabs/main-tabs.component";
import {GamesListComponent} from "./games-list/games-list.component";
import {PopupComponent} from "./popup/popup.component";
import {FooterComponent} from "./footer/footer.component";
import {ButtonLoadingComponent} from "./button-loading/button-loading.component";

export const APP_DATE_FORMATS = {
    parse: {dateInput: {month: 'short', year: 'numeric', day: 'numeric'}},
    display: {
        dateInput: {month: 'numeric', year: 'numeric', day: 'numeric'},
        yearLabel: {year: 'numeric'},
        monthLabel: {month: 'short'}
    }
};

@NgModule({
    declarations: [
        LoaderComponent,
        PopupWrapperComponent,
        MainTabsComponent,
        GamesListComponent,
        PopupComponent,
        FooterComponent,
        ButtonLoadingComponent
    ],
  imports: [
    CommonModule,
    FormsModule,
    DemoMaterialModule,
    ReactiveFormsModule,
    NgxMaskModule.forRoot(),
    MatSelectModule,
    RouterModule
  ],
    providers: [
    ],
  exports: [
    LoaderComponent,
    PopupWrapperComponent,
    MainTabsComponent,
    GamesListComponent,
    PopupComponent,
    FooterComponent,
    ButtonLoadingComponent
  ]
})
export class SharedModule { }
